<div class="campaign-collapse">
  <button
    type="button"
    class="campaign-collapse-head"
    [class.is-open]="billingOpen"
    [attr.aria-expanded]="billingOpen"
    (click)="billingOpen = !billingOpen"
  >
    <b>{{ "campaign.campaignForm.rcsBillingTitle" | translate }}</b>
    <span class="campaign-collapse-tail">
      @if (pricePerMessage !== null) {
        <span class="campaign-badge is-neutral">
          {{ pricePerMessage | currency: "BRL" : "symbol" : "1.2-2" }}
        </span>
      }
      <i
        class="mdi mdi-chevron-down campaign-collapse-caret"
        aria-hidden="true"
      ></i>
    </span>
  </button>

  @if (billingOpen) {
    <div class="campaign-collapse-body">
      <div class="campaign-summary-group">
        <div class="campaign-sum-line">
          <span class="k">
            {{ "campaign.campaignForm.rcsBillingAmountPerMessage" | translate }}
          </span>
          <span class="v">
            @if (pricePerMessage !== null) {
              {{ pricePerMessage | currency: "BRL" : "symbol" : "1.2-2" }}
            } @else {
              —
            }
          </span>
        </div>
      </div>

      <div class="campaign-summary-group">
        <span class="campaign-billing-label">
          {{ "campaign.campaignForm.rcsBillingIfCustomerReplies" | translate }}
        </span>
        <div class="campaign-billing-transition">
          <span class="campaign-billing-price">
            @if (pricePerMessage !== null) {
              {{ pricePerMessage | currency: "BRL" : "symbol" : "1.2-2" }}
            } @else {
              —
            }
          </span>
          <i
            class="mdi mdi-arrow-right campaign-billing-arrow"
            aria-hidden="true"
          ></i>
          <span class="visually-hidden">
            {{ "campaign.campaignForm.rcsBillingTransitionTo" | translate }}
          </span>
          <span class="campaign-billing-price">
            @if (sessionPrice !== null) {
              {{ sessionPrice | currency: "BRL" : "symbol" : "1.2-2" }}
            } @else {
              —
            }
          </span>
        </div>
        <p class="campaign-field-hint mt-2 mb-0">
          {{ "campaign.campaignForm.rcsBillingSessionHint" | translate }}
        </p>
      </div>
    </div>
  }
</div>
